import {
    instagram
} from "../variables";

export default () => {

    const isDetail = document.querySelector(".type-detail");

    if (isDetail) {

        const detail = () => {
            const usp = document.querySelector(".benefitBanner.position--benefitProduct")
            const cart = document.querySelector(".p-to-cart-block")

            if (usp && cart) {
                cart.insertAdjacentElement("afterend", usp)
            }
        }



        $(document).ready(function() {
            detail()
        });
    }

};